import template from './loader.html';
class LoaderComponent {}
export default {
    template: template,
    controller: LoaderComponent,
    bindings: {
        description: '@',
        showLoader: '='
    }
};


// WEBPACK FOOTER //
// ./components/loader/loader.component.js